var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("H1", { staticClass: "pageTitle isPoppins" }, [
          _vm._v("Order Details")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top20 has-text-white" }, [
          _c("b", [_vm._v("Thank you for your order!")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "top20 bandOrders has-background-darkTurk" }, [
          _c("b", { staticClass: "is-size-5" }, [
            _c("span", { staticClass: "has-text-yell" }, [
              _vm._v("Don't Forget!")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "has-text-weight-normal" }, [
              _vm._v("Assign a URL to your new Slinks and add SubSlinks!")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "top5" }, [
            _vm._v("Go to the "),
            _c(
              "b",
              {
                staticClass: "handCursor has-text-yell",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/mng")
                  }
                }
              },
              [_vm._v("Manage Services")]
            ),
            _vm._v(" page to do this.")
          ])
        ]),
        _vm._v(" "),
        _vm.order.createDate == ""
          ? _c(
              "div",
              { staticClass: "is-loading", attrs: { id: "forSpinner" } },
              [_vm._v(" ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.order
          ? _c(
              "div",
              {
                staticClass: "top40 has-text-dark",
                staticStyle: { display: "none" },
                attrs: { id: "checkoutTableDiv" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "is-pulled-right has-text-weight-bold has-text-light right10 top10",
                    attrs: { id: "backToList" },
                    on: { click: _vm.hideDetail }
                  },
                  [
                    _vm._v(
                      "\n                  < Show all orders\n              "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "accSettingsForm has-text-white" }, [
                  _c("div", { staticClass: "has-text-weight-bold" }, [
                    _vm._v(
                      "Date: " +
                        _vm._s(_vm.az.dateConvert(_vm.order.createDate))
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "has-text-weight-bold" }, [
                    _vm._v("Invoice ID: " + _vm._s(_vm.order.shortId))
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("Slink, Inc"),
                    _c("br"),
                    _vm._v("\n                341 Glenridge Rd"),
                    _c("br"),
                    _vm._v(
                      "\n                Key Biscyane, FL 33141\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "has-text-weight-bold" }, [
                    _vm._v("Billed To:")
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.order.billing.nameOnCard))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.order.billing.company))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.order.billing.address1))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.order.billing.address2,
                          expression: "order.billing.address2"
                        }
                      ]
                    },
                    [_vm._v(_vm._s(_vm.order.billing.address2))]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.order.billing.city) +
                        ", " +
                        _vm._s(_vm.order.billing.state) +
                        " " +
                        _vm._s(_vm.order.billing.zip)
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.order.billing.country))]),
                  _vm._v(" "),
                  _c("br")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "accSettingsForm has-text-white" }, [
                  _c(
                    "table",
                    { staticClass: "bottom10", attrs: { width: "100%" } },
                    [
                      _c("tr", { staticClass: "top10 has-text-weight-bold" }, [
                        _c("td", { attrs: { width: "40%" } }, [_vm._v("Item")]),
                        _vm._v(" "),
                        _c("td", { attrs: { width: "20%" } }, [
                          _vm._v("Item Type")
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "has-text-right",
                            attrs: { width: "20%" }
                          },
                          [_vm._v("Amount")]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(this.order.data, function(item, index) {
                        return _c(
                          "tr",
                          {
                            key: item.id,
                            class: { tableDarkRow: (index + 1) % 2 }
                          },
                          [
                            _c("td", [
                              item.type == "slink"
                                ? _c("span", [_vm._v("»")])
                                : _vm._e(),
                              _vm._v(_vm._s(_vm._f("itemFilter")(item.slink)))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm._f("theType")(item.type)))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "has-text-right" }, [
                              _vm._v(
                                "$" + _vm._s(_vm.az.formatCurrency(item.price))
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("tr", { staticClass: "top10 has-text-weight-bold" }, [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("td", { staticClass: "topLine has-text-right" }, [
                          _vm._v(
                            "$" + _vm._s(_vm.az.formatCurrency(_vm.order.price))
                          )
                        ])
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-darkTurk",
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/mng")
                        }
                      }
                    },
                    [_c("b", [_vm._v("Manage your Slinks")])]
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _c("br"),
                _c("br")
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14dcd7b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14dcd7b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/OrderDetails.vue
// module id = null
// module chunks = 